export default element => Array.from(element.parentNode.children).indexOf(element)
